// src/pages/SocialCalendar.js
import React from 'react';
import MiniToolPageLayout from '../components/MiniToolPageLayout';
import SocialCalendarTool from '../components/SocialCalendarTool';
import { IoCalendarOutline } from 'react-icons/io5';

// --- Page-Specific Data ---
const pageData = {
  seo: {
    title: "Social Media Content Calendar Tool | Oolook",
    description: "Visually plan, schedule, and organize your social media content across all platforms with Oolook's intuitive drag-and-drop calendar. Never miss a post again.",
    image: 'https://oolook.in/og/social-calendar.png',
    schemas: [{
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Social Media Calendar Tool",
      "operatingSystem": "All",
      "applicationCategory": "Marketing",
      "description": "A visual drag-and-drop calendar for planning and scheduling social media content across multiple platforms.",
      "url": "https://oolook.in/social-calendar",
      "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    }]
  },
  hero: {
    icon: IoCalendarOutline,
    title: "Social Calendar",
    subtitle: "Your entire social strategy, at a glance. Visually plan, schedule, and organize your content across all platforms with our intuitive drag-and-drop calendar."
  },
  guide: {
    title: "A Simpler Way to Plan",
    subtitle: "Transform your content planning from a chore into a creative process.",
    steps: [
      { title: "1. See the Big Picture", description: "View all your scheduled posts for Instagram, Facebook, X, and more in a single, unified calendar." },
      { title: "2. Drag, Drop, and Done", description: "Need to make a change? Simply drag any post to a new date or time. Your schedule updates instantly." },
      { title: "3. Collaborate with Your Team", description: "Leave comments, get approvals, and ensure everyone is aligned on the content plan, all within the calendar." }
    ]
  }
};

const SocialCalendar = () => {
  return (
    <MiniToolPageLayout seo={pageData.seo} hero={pageData.hero} guide={pageData.guide}>
      <SocialCalendarTool />
    </MiniToolPageLayout>
  );
};

export default SocialCalendar;